export enum VOLUNTEER_TABS {
	ALL = 'All',
	PENDING_APPROVAL = 'Pending Approval',
}
